module.exports = __webpack_public_path__ + "img/assembling-machine-3.5e5f41d5.png";